import { Circle, Star, AlertTriangle, XCircle } from "lucide-react";

const STATUS_CONFIG: Record<
  string,
  {
    label: string;
    icon: React.ComponentType<{ className?: string }>;
    color: string;
    bg: string;
  }
> = {
  active: { label: "Active", icon: Circle, color: "#16a34a", bg: "#dcfce7" },
  preferred: { label: "Preferred", icon: Star, color: "#d97706", bg: "#fef3c7" },
  flagged: { label: "Flagged", icon: AlertTriangle, color: "#dc2626", bg: "#fee2e2" },
  inactive: { label: "Inactive", icon: XCircle, color: "#6b7280", bg: "#f3f4f6" },
};

export function SubStatusBadge({ status }: { status: string }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.active;
  const Icon = config.icon;
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium"
      style={{ color: config.color, backgroundColor: config.bg }}
    >
      <Icon className="w-3 h-3" />
      {config.label}
    </span>
  );
}
